import React from "react";
import toast, {ToastOptions} from "react-hot-toast";
import {ToastWrapper} from "../components/Toast";

export default class DuaToast {
    static success = (message: string, options?: ToastOptions) => {
        const id = toast(<ToastWrapper type={'success'}
                                       message={message}
                                       onDismiss={() => toast.remove(id)}
        />, options);
    }
    static warning = (message: string, options?: ToastOptions) => {
        const id = toast(<ToastWrapper type={'warning'}
                                       message={message}
                                       onDismiss={() => toast.remove(id)}
        />, options);
    }
    static error = (message: string, options?: ToastOptions) => {
        const id = toast(<ToastWrapper type={'error'}
                                       message={message}
                                       onDismiss={() =>
                                           toast.remove(id)
                                       }
        />, options);
    }
}

